// Deterministic starfield — golden-angle distribution, identical to mobile ScreenBg
const STARS = Array.from({ length: 60 }, (_, i) => {
  const angle = i * 137.508;
  const r = (i / 60) * 0.98;
  return {
    top:  `${(Math.sin((angle * Math.PI) / 180) * 0.5 + 0.5) * r * 96 + 2}%`,
    left: `${(Math.cos((angle * Math.PI) / 180) * 0.5 + 0.5) * r * 96 + 2}%`,
    size: i % 12 === 0 ? 2.5 : i % 4 === 0 ? 2 : 1.5,
    opacity: 0.07 + (i % 7) * 0.04,
  };
});

export default function StarField({ density = 1, style }) {
  const count = Math.round(STARS.length * density);
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute", inset: 0, pointerEvents: "none",
        zIndex: 0, overflow: "hidden", ...style,
      }}
    >
      {STARS.slice(0, count).map((s, i) => (
        <span key={i} style={{
          position: "absolute",
          top: s.top, left: s.left,
          width: s.size, height: s.size,
          borderRadius: "50%",
          background: "#fff",
          opacity: s.opacity,
        }} />
      ))}
    </div>
  );
}
